<template>
	<v-card>
		<v-card-title>
			Azione in massa: Descrizione Screenshot Schermata del Click
		</v-card-title>
		
		<v-card-text>
			<v-row>
				<v-col>
					<v-form ref="formCambioScreenshotDelClickInMassa">
						
						<v-textarea
							label="Descrizione Screenshot Schermata del Click"
							outlined
							:value="descrizioneScreenshotDelClick"
							@input="descrizioneScreenshotDelClick = $event !== '' ? $event : null"
							auto-grow
							class="mt-1"
							:rules="[mixin_rules.required]"
						></v-textarea>
						
					</v-form>
				</v-col>
			</v-row>
		</v-card-text>
		
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				color="tertiary"
				class="black--text"
				@click="$emit('close')"
			>
				Chiudi
			</v-btn>
			<v-btn
				color="secondary"
				@click="assegnaInMassaDescrizioneScreenshotDelClick()"
				:loading="isLoadingCambioDescrizioneScreenshotDelClickInMassa"
			>
				Esegui
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
export default {
	props: {
		praticheIds: {
			default: []
		}
	},
	data() {
		return {
			isLoadingCambioDescrizioneScreenshotDelClickInMassa: false,
			descrizioneScreenshotDelClick: null
		}
	},
	
	methods: {
		assegnaInMassaDescrizioneScreenshotDelClick() {
			if (!this.$refs.formCambioScreenshotDelClickInMassa.validate()) return;
			
			this.isLoadingCambioDescrizioneScreenshotDelClickInMassa = true;
			axios.post('/api/pratiche/assegna-in-massa-descrizione-screenshot-del-click', {
				descrizione_screenshot_invio: this.descrizioneScreenshotDelClick,
				pratiche_ids: this.praticheIds
			})
				.then(() => {
					this.$emit('close');
					this.$emit('done');
				})
				.finally(() => {
					this.isLoadingCambioDescrizioneScreenshotDelClickInMassa = false;
				})
		}
	}
}
</script>